import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const SceneTagsList = Loadable(
	lazy(() => import('modules/SceneMatching/pages/SceneTagsList')),
);

const SceneCardsList = Loadable(
	lazy(() => import('modules/SceneMatching/pages/SceneCardsList')),
);

const AddSceneCard = Loadable(
	lazy(() => import('modules/SceneMatching/pages/AddSceneCard')),
);

const UpdateSceneCard = Loadable(
	lazy(() => import('modules/SceneMatching/pages/UpdateSceneCard')),
);

const ScenesGroupsList = Loadable(
	lazy(() => import('modules/SceneMatching/pages/ScenesGroupsList')),
);

const AddScenesGroup = Loadable(
	lazy(() => import('modules/SceneMatching/pages/AddScenesGroup')),
);

const UpdateScenesGroup = Loadable(
	lazy(() => import('modules/SceneMatching/pages/UpdateScenesGroup')),
);

const SCENE_MATCHING_ROUTES: IRoute[] = [
	{
		path: 'scene-matching/scene-tags',
		element: SceneTagsList,
		name: 'SceneTagsList',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: 'scene-matching/scene-cards',
		element: SceneCardsList,
		name: 'SceneCardsList',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: 'scene-matching/scene-cards/add',
		element: AddSceneCard,
		name: 'AddSceneCard',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: 'scene-matching/scene-cards/update/:sceneCardId',
		element: UpdateSceneCard,
		name: 'UpdateSceneCard',
		roles: [ROLES.ADMIN],
		private: true,
	},

	{
		path: 'scene-matching/scenes-groups',
		element: ScenesGroupsList,
		name: 'ScenesGroupsList',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'scene-matching/scenes-groups/add',
		element: AddScenesGroup,
		name: 'AddScenesGroup',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'scene-matching/scenes-groups/update/:scenesGroupId',
		element: UpdateScenesGroup,
		name: 'UpdateScenesGroup',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default SCENE_MATCHING_ROUTES;
